import Vue from "vue"
import VueRouter from "vue-router"

import Admin from "@/views/Admin"
import TestPage from "@/views/TestPage"

import Collections from "@/views/Collections"
import Dashboard from "@/views/Dashboard"
import Roles from "@/views/Roles"
import GenericEditor from "@/views/GenericEditor"
import Partners from "@/views/Partners"

import LearningActivityEditor from "@/views/LearningActivityEditor"
import ModEditor from "@/views/ModEditor"
import ModEditorChapter from "@/views/ModEditorChapter"
import ModEditorIndex from "@/views/ModEditorIndex"

import Login from "@/views/Login"

Vue.use(VueRouter)

import store from "@/store"

function guard(to, from, next) {
  console.log("GUARD store: ", store)
  if (store.state.authenticated) {
    // or however you store your logged in state
    next() // allow to enter route
  } else {
    console.log("from: ", from)
    if (from.name !== "login") {
      next("/login") // go to '/login'
    }
  }
}

const routes = [
  {
    path: "/test",
    component: TestPage,
    name: "testpage",
    hide: true,
  },
  {
    path: "/login",
    component: Login,
    name: "login",
    hide: true,
  },
  {
    path: "/",
    beforeEnter: guard,
    name: "home",
    component: Admin,
    children: [
      {
        name: "modeditor",
        plural: "Modules",
        path: "modeditor",
        component: ModEditorIndex,
        children: [
          {
            name: "modeditormodchapter",
            plural: "Modules",
            path: ":mod/:chapter",
            component: ModEditorChapter,
            props: true,
            hide: true,
          },
          {
            name: "modeditormod",
            plural: "Modules",
            path: ":mod",
            component: ModEditor,
            props: true,
            hide: true,
          },
        ],
      },
      {
        name: "Partner",
        plural: "Partners",
        path: "partner",
        component: Partners,
      },
      {
        name: "Collection",
        plural: "Collections",
        path: "collection",
        component: Collections,
      },
      {
        name: "Dashboard",
        path: "dashboard",
        component: Dashboard,
      },
      {
        name: "HistoricalThinking",
        plural: "HistoricalThinking",
        path: "HistoricalThinking",
        component: GenericEditor,
      },
      {
        name: "Language",
        plural: "Languages",
        path: "language",
        component: GenericEditor,
      },
      {
        name: "LearningActivity",
        plural: "LearningActivities",
        path: "/LearningActivity",
        component: LearningActivityEditor,
      },
      {
        name: "License",
        plural: "Licenses",
        path: "license",
        component: GenericEditor,
      },
      {
        name: "Role",
        plural: "Roles",
        path: "role",
        component: GenericEditor,
      },
      {
        name: "Redirect",
        plural: "Redirects",
        path: "redirect",
        component: GenericEditor,
      },
      {
        name: "TeachingChallenges",
        plural: "TeachingChallenges",
        path: "TeachingChallenges",
        component: GenericEditor,
      },
      {
        name: "TeachingMethods",
        plural: "TeachingMethods",
        path: "TeachingMethods",
        component: GenericEditor,
      },
    ],
  },
  {
    path: "/about",
    name: "about",
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/About.vue"),
  },
]

const router = new VueRouter({
  mode: "hash",
  base: process.env.BASE_URL,
  routes,
})

export default router
